import LegalLayout, { LegalSection, LegalList } from "@/pages/legal/LegalLayout";
import { COMPANY } from "@/lib/company";

export default function PrivacyPolicyPage() {
  return (
    <LegalLayout
      title="Privacy Policy"
      subtitle="Informativa sul trattamento dei dati personali resa ai sensi degli artt. 13 e 14 del Regolamento (UE) 2016/679 (GDPR) e del D.Lgs. 196/2003 (Codice Privacy), come modificato dal D.Lgs. 101/2018."
      updated="giugno 2026"
      testId="privacy-policy-page"
    >
      <LegalSection number="1" title="Titolare del trattamento">
        <p>
          Il Titolare del trattamento dei dati personali raccolti tramite il sito {COMPANY.site} e
          nell'ambito del servizio di visite mediche assistite a domicilio è:
        </p>
        <p>
          <strong>{COMPANY.name}</strong>
          <br />
          Sede legale: {COMPANY.address}
          <br />
          P.IVA e C.F.: {COMPANY.vat} · REA: {COMPANY.rea}
          <br />
          Email: <a href={`mailto:${COMPANY.email}`} className="text-[#5B2C91] underline underline-offset-2">{COMPANY.email}</a>
        </p>
        <p>
          Per qualsiasi richiesta relativa al trattamento dei propri dati personali, l'interessato può
          scrivere all'indirizzo email sopra indicato.
        </p>
      </LegalSection>

      <LegalSection number="2" title="Tipologie di dati trattati">
        <p><strong>a) Dati di navigazione.</strong> I sistemi informatici e le procedure software preposte al
          funzionamento del sito acquisiscono, nel corso del loro normale esercizio, alcuni dati la cui
          trasmissione è implicita nell'uso dei protocolli di comunicazione di Internet (es. indirizzi IP,
          orario della richiesta, codice di risposta del server). Si tratta di informazioni utilizzate al
          solo fine di garantire il corretto funzionamento e la sicurezza del sito e non sono associate a
          interessati identificati.</p>
        <p><strong>b) Dati forniti volontariamente dall'utente.</strong> Il contatto con il Titolare avviene
          principalmente tramite WhatsApp. In tale sede possono essere trattati: nome e cognome, numero di
          telefono, indirizzo del domicilio presso cui effettuare la visita, informazioni necessarie
          all'organizzazione dell'appuntamento e il contenuto dei messaggi inviati.</p>
        <p><strong>c) Categorie particolari di dati (dati relativi alla salute).</strong> Per l'organizzazione
          e l'erogazione della visita medica assistita possono essere trattati dati relativi allo stato di
          salute dell'interessato ai sensi dell'art. 9 GDPR: sintomi e motivo della richiesta, parametri e
          rilevazioni acquisiti durante la visita tramite il dispositivo TytoCare (es. auscultazione,
          temperatura, immagini otoscopiche), referti e documentazione clinica redatta dal medico.</p>
      </LegalSection>

      <LegalSection number="3" title="Finalità e basi giuridiche del trattamento">
        <LegalList
          items={[
            <span key="1"><strong>Riscontro alle richieste di contatto e organizzazione della visita</strong> — base giuridica: esecuzione di misure precontrattuali e del contratto (art. 6, par. 1, lett. b GDPR).</span>,
            <span key="2"><strong>Erogazione della prestazione sanitaria a domicilio</strong> (trattamento di dati relativi alla salute) — basi giuridiche: consenso esplicito dell'interessato (art. 9, par. 2, lett. a GDPR) e finalità di diagnosi, assistenza e terapia sanitaria da parte di professionisti sanitari soggetti al segreto professionale (art. 9, par. 2, lett. h GDPR e art. 75 del Codice Privacy).</span>,
            <span key="3"><strong>Adempimenti amministrativi, contabili e fiscali</strong> — base giuridica: obbligo legale (art. 6, par. 1, lett. c GDPR).</span>,
            <span key="4"><strong>Sicurezza del sito, prevenzione di abusi, accertamento e difesa di diritti in sede giudiziaria</strong> — base giuridica: legittimo interesse del Titolare (art. 6, par. 1, lett. f GDPR).</span>,
          ]}
        />
        <p>
          Il conferimento dei dati indicati alle lettere b) e c) del punto 2 è necessario per
          l'organizzazione ed erogazione del servizio: il mancato conferimento comporta l'impossibilità
          di fornire la prestazione richiesta. Non viene svolta alcuna attività di profilazione né alcun
          processo decisionale automatizzato ai sensi dell'art. 22 GDPR.
        </p>
      </LegalSection>

      <LegalSection number="4" title="Modalità del trattamento">
        <p>
          Il trattamento è effettuato con strumenti informatici e telematici, con logiche strettamente
          correlate alle finalità indicate e mediante l'adozione di misure tecniche e organizzative
          adeguate a garantire la sicurezza, l'integrità e la riservatezza dei dati (art. 32 GDPR),
          anche in relazione alla particolare natura dei dati sanitari. I dati relativi alla salute sono
          trattati esclusivamente da professionisti sanitari abilitati, tenuti al segreto professionale,
          e da personale autorizzato e istruito ai sensi dell'art. 29 GDPR.
        </p>
      </LegalSection>

      <LegalSection number="5" title="Destinatari dei dati">
        <p>I dati personali potranno essere comunicati, per le finalità sopra indicate, a:</p>
        <LegalList
          items={[
            "medici, infermieri e altri professionisti sanitari coinvolti nell'erogazione della visita, in qualità di autonomi titolari o autorizzati al trattamento;",
            "TytoCare Ltd. e i fornitori della piattaforma tecnologica di telemedicina utilizzata per l'esecuzione della visita, in qualità di responsabili del trattamento ex art. 28 GDPR;",
            "fornitori di servizi informatici, di hosting e di comunicazione, nominati responsabili del trattamento;",
            "consulenti amministrativi, contabili, fiscali e legali del Titolare;",
            "autorità pubbliche e organi di vigilanza, nei casi previsti dalla legge.",
          ]}
        />
        <p>I dati personali non sono in alcun caso diffusi né ceduti a terzi per finalità di marketing.</p>
      </LegalSection>

      <LegalSection number="6" title="Utilizzo di WhatsApp e trasferimenti extra-UE">
        <p>
          Il canale principale di contatto è WhatsApp, servizio fornito da WhatsApp Ireland Limited
          (gruppo Meta). Utilizzando WhatsApp, alcuni dati (numero di telefono, metadati e contenuto
          delle conversazioni, protette da crittografia end-to-end) sono trattati da Meta secondo la
          relativa informativa privacy, consultabile su{" "}
          <a
            href="https://www.whatsapp.com/legal/privacy-policy-eea"
            target="_blank"
            rel="noopener noreferrer"
            className="text-[#5B2C91] underline underline-offset-2"
          >
            whatsapp.com/legal/privacy-policy-eea
          </a>
          . Tali trattamenti possono comportare il trasferimento di dati verso Paesi extra-UE (in
          particolare gli Stati Uniti); in tal caso il trasferimento avviene sulla base di decisioni di
          adeguatezza della Commissione europea (EU-U.S. Data Privacy Framework) e/o di clausole
          contrattuali standard ex art. 46 GDPR. Anche la piattaforma di telemedicina TytoCare può
          comportare trasferimenti extra-UE, assistiti dalle medesime garanzie.
        </p>
      </LegalSection>

      <LegalSection number="7" title="Periodo di conservazione">
        <LegalList
          items={[
            "dati di contatto e messaggi relativi a richieste non seguite da visita: fino a 12 mesi dall'ultimo contatto;",
            "dati amministrativi, contabili e fiscali: 10 anni, ai sensi dell'art. 2220 c.c. e della normativa tributaria;",
            "documentazione sanitaria e referti: per i termini di conservazione previsti dalla normativa vigente in materia di documentazione sanitaria;",
            "dati trattati per la difesa di diritti in giudizio: per la durata del contenzioso e fino allo spirare dei termini di prescrizione.",
          ]}
        />
      </LegalSection>

      <LegalSection number="8" title="Diritti dell'interessato">
        <p>
          Ai sensi degli artt. 15-22 GDPR, l'interessato ha il diritto di ottenere dal Titolare
          l'accesso ai propri dati personali, la rettifica, la cancellazione, la limitazione del
          trattamento, la portabilità dei dati, nonché di opporsi al trattamento fondato sul legittimo
          interesse. Qualora il trattamento sia basato sul consenso, l'interessato può revocarlo in
          qualsiasi momento, senza pregiudizio per la liceità del trattamento effettuato prima della
          revoca.
        </p>
        <p>
          Le richieste possono essere inviate a{" "}
          <a href={`mailto:${COMPANY.email}`} className="text-[#5B2C91] underline underline-offset-2">{COMPANY.email}</a>.
          L'interessato ha inoltre il diritto di proporre reclamo al Garante per la protezione dei dati
          personali (
          <a
            href="https://www.garanteprivacy.it"
            target="_blank"
            rel="noopener noreferrer"
            className="text-[#5B2C91] underline underline-offset-2"
          >
            www.garanteprivacy.it
          </a>
          ) ai sensi dell'art. 77 GDPR, ovvero di adire le opportune sedi giudiziarie.
        </p>
      </LegalSection>

      <LegalSection number="9" title="Dati di minori">
        <p>
          Il servizio comprende visite pediatriche. I dati personali dei minori sono conferiti e
          trattati esclusivamente previa richiesta e con il consenso di chi esercita la responsabilità
          genitoriale o la tutela, che dichiara di essere legittimato a fornirli.
        </p>
      </LegalSection>

      <LegalSection number="10" title="Modifiche alla presente informativa">
        <p>
          Il Titolare si riserva il diritto di modificare o aggiornare la presente informativa, anche in
          conseguenza di modifiche normative. Le versioni aggiornate saranno pubblicate su questa pagina
          con indicazione della data di ultimo aggiornamento. Si invita l'utente a consultarla
          periodicamente.
        </p>
      </LegalSection>
    </LegalLayout>
  );
}
